// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"855":"2a845ec0","939":"33b3bd5e"}[chunkId] + ".chunk.css";
};